import type { Dispositif } from '@/features/domaine/types/opco'
import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const DispositifLibelle: UnionTypeLibelle<Dispositif> = {
  CAPP: "Contrat d'apprentissage",
  CPRO: 'Contrat de professionnalisation',
  PROA: 'Reconversion ou promotion par alternance',
  AF: 'Action de formation',
  FPE: 'FPE',
  // DR: 'Demande de remboursement',
} as const

export const DispositifLibelleCreation: UnionTypeLibelle<Dispositif> = {
  CAPP: "Nouveau contrat d'apprentissage",
  CPRO: 'Nouveau contrat de professionnalisation',
  PROA: 'Nouvelle reconversion ou promotion par alternance (PROA)',
  AF: 'Nouvelle Action de formation',
  FPE: 'Nouvelle demande FPE',
  // DR: 'Nouvelle demande de remboursement',
} as const
